module.exports = __webpack_public_path__ + "img/08_jakob-owens.45f96c5a.jpg";